export function get_hardware_limits(viewer) {
    const limits = {
        MAX_LIGHTS: -1,
        MAX_SHADOWCASTING_LIGHTS: -1
    };
    // We check WebGL1 constants via Babylon's EngineCapabilities
    const capabilities = viewer.engine.getCaps();
    // Check WebGL2 constants
    let max_vertex_uniform_blocks = -1;
    const webgl2_context = viewer.engine._gl;
    if (webgl2_context && viewer.engine.webGLVersion === 2) {
        max_vertex_uniform_blocks = webgl2_context.getParameter(webgl2_context.MAX_VERTEX_UNIFORM_BLOCKS);
    }
    // Uniform inventory: https://i-p-e-x.atlassian.net/wiki/spaces/IV/pages/36263199561/Uniform+inventory
    // Calculate maximum number of lights and shadow casting lights based on hardware limitations.
    // When doing this we work with the following assumptions about uniform usage per light (without shadows):
    // Spotlights 5
    // Line lights 7.
    // Point light 4
    // Spot lights with shadows: 11
    // We currently ignore the fact that light can start having shadows during their lifetime when we calculate maximum lights.
    // Uniforms are not taken into account when deciding MAX_SHADOW_CASTING_LIGHTS
    // Current maximum lights that can affect a material is set in AssetManager to 64. However, the limits we set here are used in the LightSystem when adding lights.
    // Max lights are currently limited by the number of uniform blocks for webGL2. Each light adds a new block. Two other blocks exist; one for Material and one for Scene.
    // We also count on there being an hemispheric light taking up one UBO
    // The vertex and fragments blocks limit are the same.
    if (max_vertex_uniform_blocks !== -1) {
        limits.MAX_LIGHTS = max_vertex_uniform_blocks - 3;
    }
    else {
        // For WebGL1 max lights are limited by the number of fragment uniform vectors. 7 is the maximum number of uniforms that a light adds to the scene (line lights add the most).
        // Since this is calulated based on a worse case scenario, we usually have some headroom here if we use different kinds of lights with and without shadows.
        // 36 is the number of uniform vectors that we use in the fragment shader, not counting the lights.
        // This does not help on all Android devices, some of which fails anyway.
        // Each object clipping plane will add 3 additional uniforms (vec4 vClipPlane4; vec3 vMinWorldBBox4;vec3 vMaxWorldBBox4;)
        const worst_case_nr_of_uniforms_per_light = 7;
        const nr_of_clipping_plane_uniforms = 3;
        // The number of max fragment and vertex uniforms are the same.
        // eslint-disable-next-line max-len
        limits.MAX_LIGHTS = Math.floor((capabilities.maxFragmentUniformVectors - 36 - nr_of_clipping_plane_uniforms) / worst_case_nr_of_uniforms_per_light);
    }
    // (WebGL1) issue when many shadows: Too many varying vectors. Varying vectors other than lights (5): vPositionW, vNormalW, vAlbedoUV, vReflectivityUV, vBumpUV;
    // We currently add a maximum of 2 varyings per light: vPositionFromLight and vDepthMetric
    // For each clipping plane we potentially add 2 varyings: float fClipDistance and float fInsideMesh
    const nr_of_clipping_planes_varyings = 2;
    const nr_of_lights_based_on_varyings = Math.floor((capabilities.maxVaryingVectors - 5 - nr_of_clipping_planes_varyings) / 2);
    // Issue when many shadows: Too many image texture units. Texture image units other than shadows (4): albedoSampler; reflectivitySampler; environmentBrdfSampler; bumpSampler;
    // 2 is subtracted from the MAX_TEXTURE_IMAGE_UNITS since some Android devices use an additional 2 samplers for reflectivity, if lacking shader extension for texture LOD
    const nr_of_lights_based_on_image_units = capabilities.maxTexturesImageUnits - 4 - 2;
    limits.MAX_SHADOWCASTING_LIGHTS = Math.min(nr_of_lights_based_on_image_units, nr_of_lights_based_on_varyings);
    return limits;
}
//# sourceMappingURL=HardwareLimits.js.map